import {
    LOAD_LIST,
    LOAD_PAGINATION,
    LOAD_NEW_LIST,
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getLoadList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({ ...payload, }).toString();
        const url = `v1/LoadPlan/GetLoadPlanList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                dispatch({
                    type: LOAD_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: LOAD_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const getNewLoadList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({ ...payload, }).toString();
        const url = `v1/LoadPlan/NewLoadPlanList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200) {
                dispatch({
                    type: LOAD_NEW_LIST,
                    payload: result || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const createNewLoad = (payload) => {
    const url = `v1/LoadPlan/CreateLoadPlan`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', searchText: '' }
            await getLoadList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateSalesDetails = (payload) => {
    const url = `v1/SalesOrder/UpdateSalesOrder`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getSalesList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return false;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getLoadPlanByID = (payload) => {
    const url = `v1/LoadPlan/GetLoadPlanByID?LoadPlanId=${payload}`;
    return APICall('get', payload, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result?.data;
        } else {
            return false;
        }
    }, error => {
        return false;
    });
}

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const updateLoadPlan = (payload) => {
    const url = `v1/LoadPlan/UpdateLoadPlan`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return false;
    });
}